
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/study-abroad-consultants-in-bangalore",
      function () {
        return require("private-next-pages/study-abroad-consultants-in-bangalore.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/study-abroad-consultants-in-bangalore"])
      });
    }
  